/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2024 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Print Message styles
 *
 * @file PrintMessageStyles.jsx
 * @author Gladson Samuel S
 */

import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import mixins from '../../../../assets/styles/mixins.scss';

export const Container = styled('div')({
  '&&': {
    display: 'none',
    padding: 48,
    gap: 48,
    flexDirection: 'column',

    '@media print': {
      display: 'flex',
      visibility: 'visible'
    }
  }
});

export const TextContainer = styled('div')({
  '&&': {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  }
});

export const ContentContainer = styled('div')({
  '&&': {
    display: 'flex',
    justifyContent: 'center'
  }
});

export const Title = styled(Typography)({
  '&&': {
    color: mixins.blackColor,
    fontSize: 32,
    fontFamily: 'TT Commons',
    fontWeight: 700,
    lineHeight: '32px'
  }
});

export const Description = styled(Typography)({
  '&&': {
    color: mixins.blackColor,
    fontSize: 18,
    fontFamily: 'TT Commons',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: 0.24
  }
});

export const Illustration = styled('img')({
  '&&': {
    width: 440,
    height: 606
  }
});
